import React from "react";
import "./Blue_Btn.css";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Blue_Btn({ btnText, onClick,lefticon }) {
  return (
    <>
      <section className="Blue_Btn_holder">
        <Button className="Blue_Btn theme_bg_colour" onClick={onClick}>
          {lefticon && (
            <FontAwesomeIcon icon={lefticon} className="inner_icon" />
          )}
          {btnText}
        </Button>
      </section>
    </>
  );
}

export default Blue_Btn;
